import { useCallback } from 'react';

export interface ScrollIntoViewOptions {
	behavior?: ScrollBehavior;
	block?: ScrollLogicalPosition;
	inline?: ScrollLogicalPosition;
}

export interface ScrollIntoView {
	handleFocus: () => void;
}

const defaultOptions: ScrollIntoViewOptions = {
	behavior: 'smooth',
	block: 'center',
};

/**
 * Returns a function to scroll the ref's element into view.
 * @param elementRef - Ref to any HTMLElement (input, div, li, etc.)
 * @param options - Optional scroll options (behavior, block, inline). Defaults: { behavior: 'smooth', block: 'center' }
 */
export const useScrollIntoView = (
	elementRef: React.RefObject<HTMLElement | null>,
	options: ScrollIntoViewOptions = defaultOptions
): ScrollIntoView => {
	const { behavior = 'smooth', block = 'center', inline } = options;
	const handleFocus = useCallback((): void => {
		if (elementRef?.current) {
			elementRef.current.scrollIntoView({ behavior, block, inline });
		}
	}, [elementRef, behavior, block, inline]);

	return { handleFocus };
};
